import { documentToHash } from "../core/utils";
import { EventContext, EventName } from "../types";

export async function getUserInfo(context: EventContext, eventName: EventName) {
  // list of domains to avoid cors erros to fetch VTEX IO endpoint
  const PROD_DOMAINS: Record<string, Record<string, string>> = {
    "animale": {
      "store": "https://www.animale.com.br",
      "checkout": "https://secure.animale.com.br",
    },
    "farm": {
      "store": "https://lojafarm.myvtex.com"
    },
    "mariafilo": {
      "store": "https://mariafilo.myvtex.com",
      "checkout": "https://secure.mariafilo.com.br",
    },
    "lojacrisbarros": {
      "store": "https://lojacrisbarros.myvtex.com",
      "checkout": "https://secure.crisbarros.com.br",
    },
    "lojaoffpremium": {
      "store": "https://lojaoffpremium.myvtex.com",
      "checkout": "https://secure.offpremium.com.br",
    },
    "bynv": {
      "store": "https://bynv.myvtex.com",
    },
    "fabula": {
      "store": "https://lojafabula.myvtex.com",
    },
  };

  const domain = PROD_DOMAINS[context.account || 'https://www.animale.com.br']?.[context.platform || 'store'];

  if (!domain) return { customer: { email: context.userEmail, id: context?.userId }, address: null };

  try {
    const api = `${domain}/_v/user-info`;
    const response = await fetch(api, {
      method: 'POST',
      body: JSON.stringify({ email: context.userEmail })
    });

    if (response.status !== 200) {
      // profile/edit and checkout route; we get the info directly from the input text
      if (context?.manuallyInfo && context.manuallyInfo?.cpf) {
        const { cpf, birthDate, phone, firstName, lastName, email, email_optin } = context.manuallyInfo
        const document = cpf?.replace(/\D/g, '')
        const hashedDocument = await documentToHash(document)

        return {
          address: null,
          customer: {
            email,
            phone,
            document,
            lastName,
            birthDate,
            firstName,
            email_optin,
            homePhone: phone,
            cpf: hashedDocument,
          }
        };
      }

      return { customer: { email: context.userEmail, id: context?.userId }, address: null };
    }

    const res = await response.json();
    const document = res?.customer?.document?.replace(/\D/g, '')
    const hashedDocument = await documentToHash(document)

    return { ...res, customer: { ...res.customer, cpf: hashedDocument, document } }
  } catch (_) {
    // profile/edit and checkout route; we get the info directly from the input text
    if (context?.manuallyInfo && context.manuallyInfo?.cpf) {
      const { cpf, birthDate, phone, firstName, lastName, email, email_optin } = context.manuallyInfo
      const document = cpf?.replace(/\D/g, '')
      const hashedDocument = await documentToHash(document)

      return {
        address: null,
        customer: {
          email,
          phone,
          document,
          lastName,
          birthDate,
          firstName,
          email_optin,
          homePhone: phone,
          cpf: hashedDocument,
        }
      };
    }

    return { customer: { email: context.userEmail, id: context?.userId }, address: null };
  }
}